import { ColumbusSymbol } from '@clickbar/columbus-vue';
import { TuiTooltipDirective } from '@clickbar/tailwindui-vue';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import { Link, createInertiaApp } from '@inertiajs/vue3';
import { GesturePlugin } from '@vueuse/gesture';
import { MotionPlugin } from '@vueuse/motion';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';

import { createColumbusProvider } from './ColumbusProvider';
import sentryVuePlugin from './sentry';

import type { DefineComponent } from 'vue';

const appName = globalThis.document.querySelectorAll('title')[0]?.textContent ?? 'Laravel';
const titlePrefix = Object.hasOwn(globalThis.document.documentElement.dataset, 'orb') ? '🔮 ' : '';

void createInertiaApp({
  title: (title: string) => `${titlePrefix}${title} - ${appName}`,
  progress: {
    color: '#4B5563',
  },
  resolve: (name: string) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob<DefineComponent>('./Pages/**/*.vue'),
    ),
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(autoAnimatePlugin)
      .use(GesturePlugin)
      .use(MotionPlugin)
      .use(sentryVuePlugin)
      .directive('tui-tooltip', TuiTooltipDirective)
      .component('inertia-link', Link)
      .component('InertiaLink', Link)
      .provide(ColumbusSymbol, createColumbusProvider())
      .mount(el);
  },
});

// @ts-expect-error We don't have a type definition for this
globalThis.mediaLibraryTranslations = {
  name: 'Name',
  fileTypeNotAllowed: 'Dieser Dateityp ist nicht erlaubt',
  tooLarge: 'Datei zu groß, max',
  tooSmall: 'Datei zu klein, min',
  tryAgain: 'bitte versuchen Sie es erneut',
  somethingWentWrong: 'Beim Hochladen ist ein Fehler aufgetreten',
  selectOrDrag: 'Datei(en) auswählen oder hier ablegen',
  selectOrDragMax: 'Maximal {maxItems} {file} auswählen oder hier ablegen',
  file: { singular: 'Datei', plural: 'Dateien' },
  anyImage: 'Bild',
  anyVideo: 'Video',
  goBack: 'Zurück',
  dropFile: 'Datei zum hochladen hier ablegen',
  dragHere: 'Datei hier ablegen',
  remove: 'Entfernen',
  download: 'Download',
};
